import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
export const EP_NOTE_TAB_HISTORY_QUERY = gql `
  query EPNoteTabHistory($noteTabID: ID!) {
    ep_noteTabDetails(noteTabID: $noteTabID) {
      id
      data {
        title
        version
      }
      history {
        title
        content
        version
        sequence
        ts
      }
    }
  }
`;
export function useNoteTabHistoryQuery(options) {
    return useGQLQuery(EP_NOTE_TAB_HISTORY_QUERY, options);
}
